import { motion } from "framer-motion";

const trainings = [
  {
    title: "Silový tréning",
    description:
      "Buduj silu a svalovú hmotu. Individuálne zostavené tréningy podľa tvojich cieľov a schopností.",
    image:
      "https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg?auto=compress&cs=tinysrgb&w=800",
    tag: "Základný program",
  },
  {
    title: "Kardio",
    description:
      "Zlepši vytrvalosť, spáľ tuk a posilni kardiovaskulárny systém s efektívnymi kardiofázami.",
    image:
      "https://images.pexels.com/photos/2294361/pexels-photo-2294361.jpeg?auto=compress&cs=tinysrgb&w=800",
    tag: "Vytrvalosť",
  },
  {
    title: "Strečing",
    description:
      "Zvýš pohyblivosť, predchádzaj zraneniam a urýchluj regeneráciu cielenými strečingovými cvičeniami.",
    image:
      "https://images.pexels.com/photos/4943912/pexels-photo-4943912.jpeg?auto=compress&cs=tinysrgb&w=800",
    tag: "Regenerácia",
  },
  {
    title: "Výživa",
    description:
      "Personalizovaný jedálniček a výživové poradenstvo šité na mieru tvojim cieľom a životnému štýlu.",
    image:
      "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=800",
    tag: "Zdravé stravovanie",
  },
];

export default function Trainings() {
  return (
    <section
      id="treningy"
      className="py-24 lg:py-32 relative overflow-hidden"
      style={{ background: "#252540" }}
    >
      {/* Top gradient */}
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#1C1C2E] to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#F72585] block mb-3">
            Čo ponúkam
          </span>
          <h2
            className="text-4xl lg:text-5xl font-black uppercase tracking-tight text-white"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            TYPY TRÉNINGOV
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trainings.map((t, i) => (
            <motion.div
              key={t.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12, duration: 0.6 }}
              data-testid={`training-card-${i}`}
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
              style={{ height: "340px" }}
            >
              {/* Background image */}
              <img
                src={t.image}
                alt={t.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C2E] via-[#1C1C2E]/50 to-transparent" />
              {/* Hover glow border */}
              <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-[#F72585]/60 transition-all duration-300" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block text-xs font-bold tracking-wider uppercase text-[#F72585] bg-[#F72585]/10 rounded-full px-3 py-1 mb-3">
                  {t.tag}
                </span>
                <h3
                  className="text-xl font-black text-white mb-2"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {t.title}
                </h3>
                <p
                  className="text-sm text-zinc-300 leading-snug"
                  style={{
                    opacity: 0,
                    transform: "translateY(8px)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = "1";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  {t.description}
                </p>
              </div>

              {/* Hover description reveal via CSS */}
              <style>{`
                .group:hover .training-desc { opacity: 1 !important; transform: translateY(0) !important; }
              `}</style>
              <p
                className="training-desc absolute bottom-16 left-5 right-5 text-sm text-zinc-300 leading-snug"
                style={{
                  opacity: 0,
                  transform: "translateY(8px)",
                  transition: "all 0.3s ease",
                }}
              >
                {t.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Bottom gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#1C1C2E] to-transparent pointer-events-none" />
    </section>
  );
}
